/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCcChip = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 20H2V4h20zM9.958 13.835l-1.347 1.398H5v1.12c0 .772.602 1.399 1.346 1.399h5.384v-3.917zm2.311 0v3.917h5.385c.743 0 1.346-.627 1.346-1.4v-1.119h-3.47l-1.48-1.398zM5 11.876v2.798h3.389l1.188-1.234v-1.564zm9.423 0v1.555l1.315 1.243H19v-2.798zm-4.308-1.679v3.078h3.77v-3.078zM5 8.797v2.52h4.577v-1.284L8.39 8.798zm10.611 0-1.188 1.236v1.283H19V8.798zM6.346 6C5.602 6 5 6.627 5 7.4v.838h3.611l1.347 1.4h1.773V6zm5.924 0v3.638h1.772l1.347-1.4H19V7.4c0-.773-.603-1.4-1.346-1.4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCcChip as CcChip };
